/* Built In Imports */
/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';
import MediaEmbedV2 from '@components/Embeds/MediaEmbedV2';
import SectionTitle from '@components/Headings/SectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SingleLineText from '@components/UI/SingleLineText';
import config from '@config';
/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const OTPQuoteSection = ({ sectionContent, region, language }) => {
    return (
        <Box position={'relative'}>
            <LazyLoadImageComponent
                src='https://www.datocms-assets.com/46272/1743407884-otpquotebgicon.png'
                w="324px"
                h="140px"
                alt="isha logo"
                objectFit="contain"
                position={'absolute'}
                top={'7rem'}
                left={'-2.4rem'}
                display={{base:'none', md: 'none', lg: 'block'}}
            />
            <Box
                // bgImage={{ base: '', md: `url(${config.imgPath}/d/46272/1733835195-right_quote.png)` }}
                // bgRepeat={'no-repeat'}
                // bgPosition={'right 80%'}
                bg={'linear-gradient(180deg, #FEF8E2 0%, rgba(254, 248, 226, 0) 94.38%)'}
                width={'100%'}
            >
                <Box width={{ base: "286px", sm: "286px", md: '532px', lg: "587px" }}
                    display={"flex"} flexDirection={"column"}
                    alignItems={"center"}
                    fontFamily={"FedraSansStd-book"}
                    margin={'auto'}
                    paddingTop={{ base: '20%', md: '6%' }}
                    paddingBottom={{ base: '10%', md: '3%' }}
                >
                    <Box
                        display="inline"
                        pos="relative"
                        top={{ base: '-5px', md: '-5px' }}
                    >
                        <svg width="41" height="32" viewBox="0 0 41 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M39.865 24.0149C40.2309 22.6564 40.7984 20.5475 40.0924 18.3683C39.5318 16.637 38.5392 16.0096 36.07 13.8686C31.5314 9.93381 29.2541 7.91665 28.8604 5.48703C28.4146 2.73745 29.958 0.632672 29.3918 0.193769C28.74 -0.311909 26.1463 2.04397 24.5347 4.87006C20.8962 11.2491 20.965 22.3059 26.3563 28.1618C27.0588 28.9249 30.719 32.9001 34.553 31.6028C38.1505 30.3856 39.5103 25.3337 39.8657 24.0156L39.865 24.0149Z" fill="#C7760E" />
                            <path d="M17.009 25.3941C17.6051 24.1198 18.5304 22.1416 18.2139 19.8727C17.9621 18.0705 17.0933 17.2796 15.0337 14.7429C11.2471 10.0798 9.35444 7.69817 9.38852 5.23725C9.42678 2.4515 11.3125 0.647201 10.8304 0.116482C10.2761 -0.494226 7.31281 1.37545 5.23515 3.8781C0.544938 9.5289 -1.30728 20.4298 2.98576 27.1323C3.545 28.006 6.45932 32.5557 10.4602 31.9436C14.2149 31.369 16.431 26.6301 17.009 25.3934V25.3941Z" fill="#C7760E" />
                        </svg>

                    </Box >
                    <Box
                        color="#000000"
                        textAlign="center"
                        fontFamily={"FedraSansStd-book-i"}
                        fontSize={{ base: '20px', lg: '24px' }}
                        // fontStyle="italic"
                        fontWeight={{base: '400', md:"350"}}
                        lineHeight={{base:"160%", md:"150%"}}
                        marginTop={"20px"}
                    >
                        {sectionContent?.[0]?.quote}
                    </Box>
                    <LazyLoadImageComponent
                        src="https://www.datocms-assets.com/46272/1743407437-sadhgurusignatureblackcolor.svg"
                        w="137px"
                        h="64px"
                        alt="isha logo"
                        objectFit="contain"
                        my={{ base: '30px', md: '30px' }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default OTPQuoteSection;
